import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/service/auth.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent {

user:any={}
  constructor(
    private authService: AuthService,
  ) { 
    this.user = this.authService.getCurrentUser()
  }

}
